import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const {
  Background: { SecondaryNav: SecondaryNavBackgroundColor },
} = themeColorSectionKeys.defaults

const ContactsListItemParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(ContactsListItemParts)

export const ContactsListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '3.25rem',
      width: '100%',
      padding: '0.75rem',
      mb: '0.5rem',
      borderRadius: '0.5rem',
      cursor: 'pointer',
      backgroundColor: SecondaryNavBackgroundColor.Default,
      _hover: {
        backgroundColor: SecondaryNavBackgroundColor.Hover,
      },
      _active: {
        backgroundColor: SecondaryNavBackgroundColor.Selected,
      },
    },
    text: {
      textStyle: textStyleKeys.Body1,
      maxWidth: 'calc(100% - .5rem)',
    },
  },
})

export const useContactsListItemStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactsListItemParts>(
    getName({ ContactsListItemStyle }),
    props,
  )
}
